import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CertificateType } from '@enumerates/private';
import { EndpointParams } from '@models/utils/endpoint-params';
import { CertificateCreateRequest, CertificateDetail, CertificateHistory, CertificateSummary } from '@views/customer/certificates/models';
import { HttpService } from '@services/http.service';

@Injectable({
    providedIn: 'root'
})
export class CertificatesService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'member', version: 1 };

    getSummary(): Observable<CertificateSummary> {
        return this.get('customer/certificates/summary', this.defaultEndpointParams);
    }

    getHistory(type?: CertificateType): Observable<CertificateHistory[]> {
        const params = type ? { type: CertificateType[type] } : undefined;

        return this.get('customer/certificates/history', this.defaultEndpointParams, params);
    }

    getById(idCertificate: string): Observable<CertificateDetail> {
        return this.get(`customer/certificates/${idCertificate}`, this.defaultEndpointParams);
    }

    create(request: CertificateCreateRequest): Observable<CertificateDetail> {
        return this.post('customer/certificates', this.defaultEndpointParams, request, this.noShowErrorNotification);
    }
}
